import { useMemo, useState } from "react";
import { toast } from "react-toastify";

// Assets
import IDot from "assets/i-dot.js";
import IPin from "assets/i-pin.js";
import IThump from "assets/i-thump.js";

import ModalDetailListing from "components/molecules/buyer-match/modal-detail-listing";
import ModalKonfirmasi from "components/molecules/buyer-match/modal-konfirmasi/modal-konfirmasi";

import { useUpdateStatusListing } from "api/buyer-match/mutation";

const FEAT = ({ val, lastItem }) => {
  const _getQubic = () => {
    if (val.includes("LT") || val.includes("LB"))
      return (
        <span>
          m<sup>2</sup>
        </span>
      );
    return "";
  };
  return (
    <>
      <span className="text-[11px] tracking-[-0.4px] leading-[18.571px] px-2 py-0.5 bg-white rounded-[4px] font-inter text-[#808285]">
        {val} {_getQubic()}
      </span>
      {!lastItem && <IDot />}
    </>
  );
};

const ButtonThump = ({ isActive, isDown, ...props }) => {
  return (
    <button
      {...props}
      className={`w-4 h-4 rounded-[4px] flex items-center justify-center ${
        isActive ? "bg-white" : ""
      } ${isDown ? "rotate-180" : ""}`}
    >
      <IThump color={!isActive ? "#fff" : "#252526"} />
    </button>
  );
};

const CardListingDetailBuyerArchived = ({
  property_locations,
  refetchListListingCustomer,
  id,
  property,
  property_images,
  status,
  user
}) => {
  const { mutate: updateStatusListing } = useUpdateStatusListing();
  const [isOpenModal, setIsOpenModal] = useState("kirim"); // kirim, detail, konfirmasi
  const [selectedProperty, setSelectedProperty] = useState(null);

  const handleCloseModal = () => {
    setIsOpenModal("");
    setSelectedProperty(null);
  };

  const DATA_FEATURE = useMemo(() => {
    if (!property) return [];

    const temp = [];

    if (property?.bedroom) temp.push(`Kamar Tidur: ${property?.bedroom}`);
    if (property?.bathroom) temp.push(`Kamar Mandi: ${property?.bathroom}`);
    if (property?.surface_area)
      temp.push(`Luas Tanah: ${property?.surface_area}`);
    if (property?.building_area)
      temp.push(`Luas Bangunan: ${property?.building_area}`);

    return temp;
  }, [property]);

  const handleCustomerTidakTertarik = (status) => {
    const data = {
      listing_customer: {
        status, // "matched", "sent", "interested", "not_interested"
      },
    };
    updateStatusListing(
      {
        id,
        data,
      },
      {
        onSuccess: () => {
          setIsOpenModal("");
          refetchListListingCustomer();
          setSelectedProperty(null);
          toast.success("Berhasil update listing status");
        },
        onError: (error) => {
          toast.error(
            error?.response?.data?.message ?? "Gagal update listing status"
          );
        },
      }
    );
  };

  return (
    <div className="py-[12px] px-4 flex items-center gap-[12px] border-b-[0.5px] border-solid border-[#D8D8D9] last:border-b-0">
      <div className="w-[64px] aspect-square rounded-[8px]">
        <img
          src={property_images?.[0]?.image?.url}
          alt={property?.title ?? "Property"}
          className="w-full h-full object-cover rounded-[8px]"
        />
      </div>

      <div className="flex flex-col justify-between items-start w-full">
        <div className="flex justify-between gap-[4px] w-full">
          <p className="flex items-center gap-1 text-[13px] tracking-[-0.4px] leading-[21px] font-inter text-[#252526]">
            <IPin /> {property_locations?.street}
          </p>

          <div className="w-[250px] flex justify-end">
            <div
              className={`flex h-fit items-center gap-1 p-0.5 rounded-[5px] ${
                status === "not_interested" ? "bg-[#FD4949]" : "bg-[#02AC5B]"
              }`}
            >
              <ButtonThump
                onClick={() => setIsOpenModal("konfirmasi-change-status")}
                isActive={status === "interested"}
              />

              <ButtonThump
                onClick={() => setIsOpenModal("konfirmasi-change-status")}
                isActive={status === "not_interested"}
                isDown={true}
              />
            </div>
          </div>
        </div>

        <div className="flex gap-[10px] justify-between w-full">
          <div>
            <p className="text-[13px] tracking-[-0.4px] leading-[21px] font-inter text-[#252526]">
              Rp{parseInt(property?.price).toLocaleString()}{" "}
              {property?.unit_price?.name?.replace("/", "Per")}
            </p>
            <p className="text-[11px] tracking-[-0.4px] leading-[18.571px] font-inter text-[#808285]">
              {property?.title}
            </p>
          </div>
          <div className="flex items-center justify-end gap-1 rounded-[2px] bg-[#FAFAFA] px-1 py-2">
            {DATA_FEATURE?.map((item, index) => (
              <FEAT
                key={`item-data-faeture-${index}`}
                val={item}
                lastItem={index === DATA_FEATURE?.length - 1}
              />
            ))}
          </div>
        </div>

        <p className="text-[11px] tracking-[-0.4px] leading-[18.571px] w-full font-inter text-[#808285] border-t-[0.5px] border-dashed border-[#DEDFDE]">
          Dibuat{" "}
          <span className="font-semibold">
            {user?.full_name}, {user?.company_name}
          </span>
        </p>
      </div>

      <ModalDetailListing
        isOpen={isOpenModal === "detail"}
        onClose={() => setIsOpenModal("")}
        slug={selectedProperty?.slug}
        onSendListing={() => setIsOpenModal("konfirmasi")}
        property_images={property_images}
        propertyId={id}
      />

      <ModalKonfirmasi
        isOpen={isOpenModal === "konfirmasi"}
        onClose={handleCloseModal}
        title="Kirim Listing ke Customer?"
        description="Listing ini akan dibagikan kepada customer melalui WhatsApp."
        leftBtnText="Batal"
        rightBtnText="Kirim Listing"
        leftBtnAction={handleCloseModal}
        rightBtnAction={handleCloseModal}
      />

      <ModalKonfirmasi
        isOpen={isOpenModal === "konfirmasi-change-status"}
        onClose={handleCloseModal}
        title="Ubah Respon Customer?"
        description="Respon customer akan diubah menjadi Tertarik untuk listing ini."
        leftBtnText="Batal"
        rightBtnText="Ubah Respon"
        leftBtnAction={handleCloseModal}
        rightBtnAction={() =>
          handleCustomerTidakTertarik(
            status === "interested" ? "not_interested" : "interested"
          )
        }
      />
    </div>
  );
};

export default CardListingDetailBuyerArchived;
